(() => {
  const config = window.hinokPairsConfig;
  if (!config || window.HinokPairsAB) return;
  const params = new URLSearchParams(location.search);
  const qa = config.preview || params.has('hinok_qa') || params.has('pair_qa');
  const forced = config.preview && ['A', 'B'].includes(params.get('pair_qa')) ? params.get('pair_qa') : '';
  const key = 'hinok_pairs_' + config.id + (qa ? '_qa' : '');
  const exposureKey = key + '_exposure';
  let assignment = null;
  let exposure = null;
  let visible = false;
  let hooked = false;
  let attempts = 0;
  const active = () => config.eligible && config.enabled && (config.preview || !qa && Number.isFinite(Date.parse(config.launch)) && Date.now() >= Date.parse(config.launch));
  function permission() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function') return null;
      if (privacy.analyticsProcessingAllowed() === false) return false;
      const optedOut = window.posthog?.has_opted_out_capturing?.();
      if (optedOut === true) return false;
      return optedOut === false && typeof posthog.get_session_id === 'function' ? true : null;
    }
    catch (error) { return null; }
  }
  function session() {
    if (!permission()) return '';
    try { const id = posthog.get_session_id(); return typeof id === 'string' && /^[a-zA-Z0-9_.:-]{1,128}$/.test(id) ? id : ''; }
    catch (error) { return ''; }
  }
  function allocated() {
    if (assignment) return assignment;
    try {
      let value = JSON.parse(localStorage.getItem(key) || 'null');
      if (!value || value.experiment !== config.id || !['A','B'].includes(value.variant) || !/^[a-f0-9-]{36}$/i.test(value.id) || forced && value.variant !== forced) {
        value = {experiment:config.id,id:crypto.randomUUID(),variant:forced || (config.preview ? 'B' : crypto.getRandomValues(new Uint8Array(1))[0] < 192 ? 'A' : 'B')};
        localStorage.setItem(key,JSON.stringify(value));
      }
      assignment = value;
      return value;
    } catch (error) { return null; }
  }
  function current(sid) {
    if (!active() || !permission() || !sid) return null;
    const a = allocated();
    if (!exposure) { try { exposure=JSON.parse(sessionStorage.getItem(exposureKey)||'null'); } catch(error){} }
    if (!a || !exposure || exposure.experiment !== config.id || exposure.assignment !== a.id || exposure.variant !== a.variant || exposure.sid !== sid || exposure.qa !== qa) return null;
    return exposure;
  }
  function properties(value=current(session())) {
    if (!value) return {};
    return {pairs_ab_id:value.experiment,pairs_ab_variant:value.variant,pairs_ab_assignment:value.assignment,pairs_ab_exposure:value.id,pairs_ab_product:value.product,pairs_ab_exposed_at:value.at,pairs_ab_qa:value.qa};
  }
  function refresh() {
    const measurable = permission();
    const a = active() && (config.preview || measurable) ? allocated() : null;
    const root=document.querySelector('[data-journey-pdp]');
    const variant=a?.variant || 'A';
    document.querySelectorAll('[data-journey-details]').forEach(button=>{button.hidden=variant!=='B';});
    if (root) root.dataset.pairsVariant=variant;
    if (measurable !== true) {
      exposure=null;
      try {sessionStorage.removeItem(exposureKey);if(measurable === false && !config.preview){localStorage.removeItem(key);assignment=null;}}catch(error){}
      return;
    }
    const sid=session();
    if (!a || !sid || !root || !visible || document.visibilityState==='hidden' || !root.querySelector('[data-journey-select]')) return;
    if (!current(sid)) {
      exposure={experiment:config.id,assignment:a.id,variant:a.variant,id:crypto.randomUUID(),sid,qa,product:config.product,at:new Date().toISOString()};
      try {sessionStorage.setItem(exposureKey,JSON.stringify(exposure));}catch(error){}
      posthog.capture('pairs_ab_exposure',properties(exposure));
      document.dispatchEvent(new CustomEvent('pairs-ab:exposed'));
    }
  }
  window.HinokPairsAB={refresh,properties,cartAttributes(sid){const value=current(sid);if(!value)return {};return {...Object.fromEntries(Object.entries(properties(value)).map(([k,v])=>[k,String(v)])),pairs_ab_session:value.sid};}};
  function init() {
    const root=document.querySelector('[data-journey-pdp]');
    if(root&&!root.dataset.pairsObserved){
      root.dataset.pairsObserved='true';
      const target=root.querySelector('legend');
      if(target)new IntersectionObserver(entries=>{visible=entries.some(e=>e.isIntersecting);refresh();},{threshold:1}).observe(target);
    }
    if(!hooked&&session()&&typeof posthog.onSessionId==='function'){hooked=true;posthog.onSessionId(refresh);}
    refresh();
    if(attempts++<20&&!hooked&&active())setTimeout(init,500);
  }
  document.addEventListener('pdp:purchase-total-change',refresh);
  document.addEventListener('visitorConsentCollected',init);
  document.addEventListener('visibilitychange',init);
  window.addEventListener('pageshow',init);
  const pending=new Map();
  document.addEventListener('cart:add',event=>{if(event.detail?.source==='pdp'&&current(session()))pending.set(event.detail.requestId,current(session()));},true);
  document.addEventListener('cart:add:done',event=>{const value=pending.get(event.detail?.requestId);pending.delete(event.detail?.requestId);if(value&&active()&&session()===value.sid)posthog.capture(event.detail.ok?'pairs_ab_atc_succeeded':'pairs_ab_atc_failed',properties(value));},true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
